import Typography from 'components/shared/Typography';
import { useFetchBlocks, useGetReportDetails } from 'services';
import { useParams } from 'react-router';
import { IBlock } from 'types';
import { LoadingReport } from './loading-block';
import classNames from 'classnames';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import { PdfBlockCard } from 'components/pdfPage/PdfBlock';

export function PDF() {
  const param = useParams();

  const { id } = param;
  const { data, isFetching, error } = useFetchBlocks(id as string);

  const { data: reportData, isFetching: isReportDetailsFetching, error: isReportDetailsError } = useGetReportDetails(id as string);

  const displayBlocks = data && data?.data?.length > 0 && !isFetching && !error;

  const blocks = data?.data as Partial<IBlock>[];

  const title = reportData && (reportData?.data?.report?.title as string);

  const filteredBlocks = blocks?.filter((block) => block.result_status !== 'error');

  const displayTitle = title && !isReportDetailsFetching && !isReportDetailsError;

  return (
    <div className={classNames('flex w-full justify-center transition-all duration-300')}>
      <div
        className={classNames(
          'flex lg:max-w-[900px] md:max-w-[800px] pb-[109px] transition-all duration-300 flex-col justify-center w-full border-none'
        )}
      >
        <div className='flex flex-col'>
          <div className={classNames('flex justify-between items-center')}>
            {displayTitle && (
              <div className='flex justify-center w-full mt-6'>
                <Typography variant='displaymd' weight='bold' className='text-shade-black'>
                  {title}
                </Typography>
              </div>
            )}
          </div>

          {error && (
            <div className='mt-[60px] flex justify-center items-center'>
              <Typography variant='displaysm' weight='semibold' className='text-shade-black'>
                There was an unexpected error while retrieving blocks
              </Typography>
            </div>
          )}
          {isFetching && (
            <div className='mt-[60px]'>
              <LoadingReport />
            </div>
          )}
          {displayBlocks && (
            <div>
              <div className='flex flex-col gap-10 mt-8 mx-8'>
                {filteredBlocks.map((block: Partial<IBlock>) => (
                  <PdfBlockCard key={block.id} block={block} reportId={id as string} />
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
